import * as THREE from 'three';
import { renderOrders } from '../../../../viewer/render-orders.ts';
// @ts-ignore
import { dxfHelpers } from '../dxfHelpers';

export default class DxfSurfaceParser {
  constructor() {}

  process3DFace(entity, insert) {
    let polygons = [];

    let polygon = this.makePolygon(
      entity.vertices[0],
      entity.vertices[1],
      entity.vertices[2],
      insert,
    );

    if (this.validPolygon(polygon)) {
      polygons.push(polygon);
    } else {
      console.log("Warning, couldn't process first polygon of 3DFACE", polygon, entity, insert);
    }

    if (entity.vertices.length > 3) {
      let polygon2 = this.makePolygon(
        entity.vertices[0],
        entity.vertices[2],
        entity.vertices[3],
        insert,
      );
      if (this.validPolygon(polygon2)) {
        polygons.push(polygon2);
      } else {
        console.log("Warning, couldn't process second polygon of 3DFACE", polygon2, entity, insert);
      }
    }

    if (polygons.length > 0) {
      return { faces: polygons };
    }
  }

  validVertex(vertex) {
    return (
      vertex &&
      (vertex.x || vertex.x === 0) &&
      (vertex.y || vertex.y === 0) &&
      (vertex.z || vertex.z === 0)
    );
  }

  validPolygon(polygon) {
    return (
      polygon &&
      this.validVertex(polygon[0]) &&
      this.validVertex(polygon[1]) &&
      this.validVertex(polygon[2])
    );
  }

  getCorrectVertex(i, length) {
    i = Math.abs(i) - 1;
    let index = i % length;
    return (length + index) % length;
  }

  processPolyfaceMesh(entity, insert) {
    let vertices = [];
    let faces = [];

    for (let i = 0; i < entity.vertices.length; i++) {
      let vertex = entity.vertices[i];

      if (vertex.polygonIndex1) {
        let p1 = vertices[this.getCorrectVertex(vertex.polygonIndex1, vertices.length)];
        let p2 = vertices[this.getCorrectVertex(vertex.polygonIndex2, vertices.length)];
        let p3 = vertices[this.getCorrectVertex(vertex.polygonIndex3, vertices.length)];
        let p4 = vertices[this.getCorrectVertex(vertex.polygonIndex4, vertices.length)];

        let polygon = [p1, p2, p3];

        if (this.validPolygon(polygon)) {
          faces.push(polygon);
        } else {
          console.log(
            "Warning, couldn't process first polygon of POLYFACE",
            polygon,
            entity,
            insert,
          );
        }

        if (this.validVertex(p4)) {
          let polygon2 = [p1, p3, p4];

          if (this.validPolygon(polygon2)) {
            faces.push(polygon2);
          } else {
            console.log(
              "Warning, couldn't process second polygon POLYFACE",
              polygon2,
              entity,
              insert,
            );
          }
        }
      } else {
        if (insert) {
          vertex = dxfHelpers.transformInsertVertex(insert, vertex);
        }
        vertices.push(vertex);
      }
    }

    return { faces: faces };
  }

  makePolygon(p1, p2, p3, insert) {
    let polygon = [
      { x: p1.x, y: p1.y, z: p1.z },
      { x: p2.x, y: p2.y, z: p2.z },
      { x: p3.x, y: p3.y, z: p3.z },
    ];

    if (insert) {
      dxfHelpers.transformInsertPolygon(insert, polygon);
    }
    return polygon;
  }

  /* pushAndReturn(faceCollection, properties, targetArray, layer) {
      let ind = faceCollection[layer].push({ polygons: targetArray, properties: properties, layer: layer });
      return faceCollection[layer][ind - 1];
  } */

  generateMeshMaterial(properties) {
    return new THREE.MeshLambertMaterial({
      color: properties.color ? properties.color : 0x0033ff,
    });
  }

  generate3DSurface(surfaceData) {
    const polygons = surfaceData.faces;
    const properties = surfaceData.properties;
    const material = this.generateMeshMaterial(properties);
    const offset = polygons[0][0];

    const vertices = [];
    for (const polygon of polygons) {
      vertices.push(polygon[0].x - offset.x, polygon[0].y - offset.y, polygon[0].z);
      vertices.push(polygon[1].x - offset.x, polygon[1].y - offset.y, polygon[1].z);
      vertices.push(polygon[2].x - offset.x, polygon[2].y - offset.y, polygon[2].z);
    }

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    geometry.computeVertexNormals();

    const surface = new THREE.Mesh(geometry, material);
    surface.name = 'Surface';

    surface.material.side = THREE.DoubleSide;

    const wireframe = this.getWireframe(surface);
    surface.position.set(offset.x, offset.y, surface.position.z);

    surface.renderOrder = renderOrders.dxfAsset.surface;
    wireframe.renderOrder = renderOrders.dxfAsset.wireframe;

    surface.add(wireframe);

    return surface;
  }

  getWireframe(surface) {
    let geometry = new THREE.WireframeGeometry(surface.geometry);
    let material = new THREE.LineBasicMaterial({ color: 0, linewidth: 2 });
    let wireframe = new THREE.LineSegments(geometry, material);
    wireframe.name = 'Wireframe';
    wireframe.visible = false;
    return wireframe;
  }
}
